"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M6.369 2.27c.888 0 1.61.723 1.61 1.61 0 1.258.197 2.49.585 3.664a1.621 1.621 0 0 1-.399 1.644L6.464 11.45c1.399 2.638 3.1 4.337 5.757 5.755l2.316-1.748c.376-.383 1.024-.534 1.593-.337 1.167.385 2.4.582 3.658.582.888 0 1.61.722 1.61 1.61v3.748a1.611 1.611 0 0 1-1.608 1.611C9.43 22.67 1 14.24 1 3.88c0-.887.722-1.61 1.61-1.61h3.76Zm0 1.073H2.61a.537.537 0 0 0-.536.538c0 9.768 7.948 17.715 17.716 17.715.295 0 .536-.24.536-.537v-3.747a.538.538 0 0 0-.536-.537c-1.373 0-2.72-.214-4.004-.639a.536.536 0 0 0-.546.129l-2.643 2.004a.534.534 0 0 1-.568.048c-3.152-1.613-5.085-3.549-6.677-6.676a.537.537 0 0 1 .05-.567l1.953-2.588c.198-.204.249-.411.186-.61a12.78 12.78 0 0 1-.636-3.995.538.538 0 0 0-.536-.538Zm16.79 5.58a.527.527 0 1 1 .588.875l-4.704 3.156a.528.528 0 0 1-.811-.336h.001l-.119-1.024-2.853 1.654a.526.526 0 1 1-.528-.912l3.42-1.981a.529.529 0 0 1 .781.354l.181.927 4.044-2.713Zm-4.778-5.237a.528.528 0 0 1 .937.48l-2.582 5.04a.526.526 0 0 1-.873.1l-.6-.838L13.57 11.3a.528.528 0 0 1-.905-.541l2.03-3.392a.526.526 0 0 1 .856-.069l.607.724 2.223-4.335ZM14.18 0l.09.005.095.023a.524.524 0 0 1 .364.477l-.004.096-.794 5.607a.526.526 0 0 1-.792.379l-.84-.595-.676 3.228a.527.527 0 1 1-1.032-.216l.81-3.87a.527.527 0 0 1 .786-.344l.799.574.695-4.912a.527.527 0 0 1 .408-.44L14.182 0h-.001Z"
  })]
});